export const infographicGreen = {
  50: '#e6f9ec',
  100: '#c2f0cf',
  200: '#99e6b0',
  300: '#68dd8f',
  400: '#36d475',
  500: '#00cb5b',
  600: '#00bb50',
  700: '#00a843',
  800: '#009637',
  900: '#007623'
};

export const infographicPurple = {
  50: '#efecf7',
  100: '#cfc4e7',
  200: '#b09dd7',
  300: '#9176c8',
  400: '#7959bc',
  500: '#613db0',
  600: '#5938aa',
  700: '#4c30a1',
  800: '#402a99',
  900: '#2d1f8a'
};

export const infographicYellow = {
  50: '#fff9e1',
  100: '#ffedb4',
  200: '#ffe284',
  300: '#ffd851',
  400: '#ffcc2b',
  500: '#ffc50e',
  600: '#ffb705',
  700: '#ffa402',
  800: '#ff9300',
  900: '#ff7300'
};

export const infographicRed = {
  50: '#ffebee',
  100: '#ffcdd3',
  200: '#ef9a9c',
  300: '#e57376',
  400: '#ef5254',
  500: '#f5403b',
  600: '#e6373a',
  700: '#d42d33',
  800: '#c7262c',
  900: '#b81a21'
};

export const qprGray = {
  50: '#f6faff',
  100: '#f1f5fa',
  200: '#eaeef2',
  300: '#dce0e4',
  400: '#b9bdc1',
  500: '#9a9ea2',
  600: '#606b7b',
  700: '#4f5765',
  800: '#3f454f',
  900: '#2c3038'
};

export const qprSecondary = {
  50: '#fbe8e6',
  100: '#ffcab8',
  200: '#fea88a',
  300: '#fd865b',
  400: '#fc6b36',
  500: '#fb500a',
  600: '#f04b05',
  700: '#e24300',
  800: '#d53c00',
  900: '#bc2f00'
};

export const qprBlue = {
  50: '#e1f5ff',
  100: '#b3e5ff',
  200: '#80d4ff',
  300: '#4bc3ff',
  400: '#21b6ff',
  500: '#00a8ff',
  600: '#069cf0',
  700: '#0d87db',
  800: '#0c76c7',
  900: '#0f55a5'
};

export const qprDarkBlue = {
  50: '#e7eaf5',
  100: '#c3cbe6',
  200: '#9caad5',
  300: '#7588c4',
  400: '#566eb8',
  500: '#3655ad',
  600: '#304da3',
  700: '#264397',
  800: '#1e3a8b',
  900: '#0f2975'
};

const theme = {
  themeName: 'QPR Theme',
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920
    }
  },
  palette: {
    primary: {
      main: qprBlue[600],
      light: qprBlue[50],
      dark: qprBlue[900],
      contrastText: '#fff'
    },
    secondary: {
      main: qprDarkBlue[900],
      light: qprDarkBlue[50],
      dark: qprDarkBlue[900],
      contrastText: '#fff'
    },
    info: {
      main: qprBlue[200],
      light: qprBlue[100],
      dark: qprBlue[300]
    },
    grey: qprGray,
    background: {
      paper: 'rgba(241, 245, 250, 0.9)',
      default: '#fff'
    }
  },
  typography: {
    htmlFontSize: 10,
    fontFamily: ['"Open Sans"', 'Roboto', '"Helvetica"', 'Arial', 'sans-serif'].join(','),
    fontWeightMedium: 500,
    h1: {
      fontSize: '9.6rem',
      letterSpacing: '-0.15rem',
      fontWeight: 300
    },
    h2: {
      fontSize: '6rem',
      letterSpacing: '-0.05rem',
      fontWeight: 300
    },
    h3: {
      fontSize: '4.8rem',
      fontWeight: 400
    },
    h4: {
      fontSize: '3.4rem',
      letterSpacing: '0.025‬rem',
      fontWeight: 400
    },
    h5: {
      fontSize: '2.4rem',
      fontWeight: 400
    },
    h6: {
      fontSize: '2rem',
      letterSpacing: '0.025rem',
      fontWeight: 600
    },
    body1: {
      fontSize: '1.6rem',
      letterSpacing: '0.05rem',
      fontWeight: 400
    },
    subtitle1: {
      fontSize: '1.6rem',
      letterSpacing: '0.015rem',
      fontWeight: 600
    },
    body2: {
      fontSize: '1.4rem',
      letterSpacing: '0.025rem',
      fontWeight: 400
    },
    subtitle2: {
      fontSize: '1.4rem',
      letterSpacing: '0.01rem',
      fontWeight: 600
    },
    button: {
      fontSize: '1.4rem',
      letterSpacing: '0.125rem',
      fontWeight: 600
    },
    caption: {
      fontSize: '1.2rem',
      letterSpacing: '0.04rem',
      fontWeight: 400
    },
    overline: {
      fontSize: '1.2rem',
      letterSpacing: '0.2‬rem',
      fontWeight: 600
    },
    body3: {
      fontSize: '1.2rem',
      letterSpacing: '0.021rem',
      fontWeight: 400
    },
    body4: {
      fontSize: '1rem',
      letterSpacing: '0.018rem',
      fontWeight: 400
    }
  },
  overrides: {
    MuiSelect: {
      select: {
        '&:focus': {
          backgroundColor: 'transparent'
        }
      }
    },
    MuiOutlinedInput: {
      root: {
        '&$focused $notchedOutline': {
          borderWidth: 1
        }
      }
    },
    MuiCssBaseline: {
      body: {
        backgroundImage:
          "linear-gradient(rgba(6, 156, 240,0.6), rgba(6, 156, 240,0.6) ), url('/BMS-Background.jpg')",
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        height: '100%',
        fontFamily: ['"Open Sans"', 'Roboto', '"Helvetica"', 'Arial', 'sans-serif'].join(','),
        fontSize: '1.4rem',
        letterSpacing: '0.025rem',
        lineHeight: '1.43'
      },
      '.customHeader': {
        color: 'white'
      },
      '.customCellRow': {
        color: qprGray[900]
      },
      '.appbar-logo': {
        backgroundImage:
          'url("data:image/svg+xml;base64,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")',
        fill: 'currentColor',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        fontSize: '2.4rem',
        transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        flexShrink: 0,
        '-moz-user-select': 'none'
      },
      '.customCanvasBackground': {
        fill: 'white'
      },
      '.PropertiesCard-paper': {
        backgroundColor: '#fff !important'
      },
      '.Map2-groupItemTitle': {
        marginBottom: '24px'
      },
      '.Map2-scrollContainer': {
        marginLeft: '8px'
      }
    }
  }
};

export default theme;
